import React from 'react';
import BrandLogo from './BrandLogo';
import '../css/ComingSoonScreen.css';

/**
 * A placeholder screen for a feature that exists but is not open yet.
 *
 * Deliberately a dead end rather than a broken page: it says the screen is
 * coming, not that something went wrong, and offers nothing to click that
 * would only fail. Used by the POS when Config -> System -> Point of Sale is
 * unticked, and written to suit anything else turned off the same way.
 *
 * @param {object} props
 * @param {string} [props.title] - What is coming. Defaults to a generic line.
 * @param {string} [props.message] - One sentence under the title.
 * @param {string} [props.brandName] - Club name shown above the title.
 * @param {string} [props.logoUrl] - Club logo, when one is configured.
 * @returns {JSX.Element}
 */
const ComingSoonScreen = ({
  title = 'Coming soon',
  message = 'This screen is being set up and will be available shortly.',
  brandName = '',
  logoUrl = '',
}) => (
  <div className="cs-page">
    <div className="cs-card">
      {/* The club's own logo, not a decorative mark — it is what tells a
          member of staff they are in the right place and simply early. */}
      {logoUrl && <BrandLogo src={logoUrl} alt={brandName || ''} className="cs-logo" />}
      {brandName && <p className="cs-brand">{brandName}</p>}
      <h1 className="cs-title">{title}</h1>
      <p className="cs-message">{message}</p>
      {/* Three dots that breathe in sequence. The only movement on the page,
          and slow enough to read as "in progress" rather than "loading" —
          nothing here is waiting on a request. */}
      <div className="cs-dots" aria-hidden="true">
        <span /><span /><span />
      </div>
    </div>
  </div>
);

export default ComingSoonScreen;
